<template>
  <div>
  <Loader v-if="!isLoaded" />
  <div class="page page-survey-questions mb-sm-5" v-if="isLoaded">
    <header class="skinny">
      <div class="container">

        <div class="row">
          <div class="header-inner col-12">
            <div class="header-primary-info">
              <a class="plain btn-q-back" @click.prevent="goBack" href="#"><i class="icon-chevron-left"></i> Save and close</a>
              <h2 class="w-100 text-center text-md-left">{{title}}</h2>
            </div>

            <div class="header-meta mt-2 mt-md-0">
              <p v-if="fakeSaving" class="header-meta-magic-date w-100 text-right mr-3"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Saving</p>
              <p v-else class="header-meta-magic-date w-100 text-right text-success mr-3"><i class="icon-check"></i> Saved</p>
              <p class="header-meta-kit-id w-100 text-right pr-4 pr-md-0">Kit ID: {{$route.params.kitId}}</p>

            </div>
          </div>

          <div class="col-12">
            <div class="progress-wrap">
              <ProgressBar :total="questionCount" :count="totalAnswered" :tick="false"/>
            </div>
          </div>
        </div>

      </div>
    </header>

    <div class="container-fluid questionnaire-description">
      <div class="container">
        <div class="row">
          <div class="col-12 subheading" v-html="heading"></div>
          <div class="col-12 description" v-if="description" v-html="description"></div>
          <div class="col-12 description" v-if="toggle">
            <a @click.prevent="showToggle = true" v-if="!showToggle" href="#">How to fill out this questionnaire. </a>
            <div v-if="showToggle" v-html="toggle"></div>
            <a @click.prevent="showToggle = false" v-if="showToggle" href="#">Hide details. </a>
          </div>
        </div>
      </div>
    </div>


    <transition name="slide-fade">


      <div class="container question-list">

        <div v-for="(question, index, count) in filteredQuestions" :key="question.id">
          <div>

            <h1 v-html="sectionTitle(index)"></h1>
            <p v-html="sectionSubtitle(index)"></p>

            <component
              v-if="isSingleAnswerQuestion(question.answerType)"
              :is="mapAnswerTypeToComponent(question.answerType)"
              :id="question.id"
              :index="question.questionNumber"
              :question="parseQuestion(question.question)"
              :answers="question.answers"
              :type="question.answerType"
              v-model="answers[question.id].answerString"
              />


            <component
              v-if="isArrayAnswerQuestion(question.answerType)"
              :is="mapAnswerTypeToComponent(question.answerType)"
              :id="question.id"
              :index="question.questionNumber"
              :question="parseQuestion(question.question)"
              :answers="question.answers"
              :type="question.answerType"
              v-model="answers[question.id].answers"
              />
          </div>
        </div><!-- loop -->

        <DynamicButton :loading="fakeSaving" :success="fakeSuccess" text="Save and next" @onClick="fakeSave" />
        <div class="mb-5"></div>
        </div><!-- container -->
      </transition>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import Number from '@/components/questions/Number'
import Boolean from '@/components/questions/Boolean'
import Date from '@/components/questions/Date'
import SingleOption from '@/components/questions/SingleOption'
import MultiOption from '@/components/questions/MultiOption'
import TextQuestion from '@/components/questions/Text'
import ProgressBar from '@/components/elements/progressBar'
import Loader from '@/components/elements/Loader'
import Vue from 'vue'
import apiStringMapping from '@/mixins/apiStringMapping'
import DynamicButton from '@/components/elements/DynamicButton'
import json from '@/config/questionnaire.json'

export default {
  name: 'SurveysQuestions',
  mixins: [ apiStringMapping ],
  components: {
    Number,
    Boolean,
    SingleOption,
    MultiOption,
    Date,
    TextQuestion,
    ProgressBar,
    Loader,
    DynamicButton
  },
  /* eslint-disable */
  data: function() {
    return {
      isLoaded: false,
      questions: [],
      answers: [],
      skipTriggers: [], // The API rules
      showTriggers: [], // The API rules
      fakeSaving: false, // Adding a saving button to the bottom just for UX
      fakeSuccess: false,
      showToggle: false,
      scrollPosition: null
    }
  },
  computed: {
    surveyType(){
      return this.$route.params.type;
    },
    heading: function () {
      const slug = this.$route.params.type
      const questionnaireJsonObj = json
      if("undefined" != typeof questionnaireJsonObj[slug] && "undefined" != typeof questionnaireJsonObj[slug].heading) {
        return questionnaireJsonObj[slug].heading
      } else {
        return ''
      }
    },
    toggle: function () {
      const slug = this.$route.params.type
      const questionnaireJsonObj = json
      if("undefined" != typeof questionnaireJsonObj[slug] && "undefined" != typeof questionnaireJsonObj[slug].toggle) {
        return questionnaireJsonObj[slug].toggle
      } else {
        return false
      }
    },
    description: function () {
      const slug = this.$route.params.type
      const questionnaireJsonObj = json
      if("undefined" != typeof questionnaireJsonObj[slug] && "undefined" != typeof questionnaireJsonObj[slug].description) {
        return questionnaireJsonObj[slug].description
      } else {
        return false
      }
    },
    title: function () {
      const tempTitle = this.slugToSample(this.$route.params.type)
      return this.sampleToDisplay(tempTitle)
    },
    filteredQuestions: function () {
      var i = 1;
      return Object.keys(this.questions).reduce((collection, key) => {
        const value = this.questions[key]
        value.questionNumber = i
        // Remove HIDDEN questions
        if (!this.skippedIds.includes(value.id) && !this.shownIds.includes(value.id)){
          collection[key] = (value)
        }

        i++
        return collection
      }, {})
    },
    // Combine questions and answers into single object
    userQuestions: function() {
      if (this.answers.length < 1 && this.questions.length < 1) return []
      return Object.keys(this.questions).map(key => {
        const question = this.questions[key]
        const answer = this.answers.filter(value => {
          return value.questionId === question.id
        })[0]
        const userAnswer = {
          userAnswers: answer ? answer.answers : [],
          userAnswersString: answer ? answer.answerString : []
        }
        return { ...question, ...userAnswer }
      })
    },

    kitList (){
      return this.$store.state.GET_KITS_RESPONSE
    },

    calculateProgress(){
      let kitId = this.$route.params.kitId
      console.log(kitId)
      for (let i = 0; i < this.kitList.length; i++){
        console.log(this.kitList[i]['id'])
        if(this.kitList[i]['id'] == kitId) {
          let surveyList = this.kitList[i]['surveysStats']
          let name = this.mapURLToSurvey(this.$route.params.type)

          for (let i = 0; i < surveyList.length; i++){
            if(surveyList[i]['surveyType'] === name) {
              return surveyList[i]
            }
          }
        }
      }
    },

    selectedSurvey (){
      return _.find(this.selectedKit.surveysStats, 'surveyType', this.mapURLToSurvey(this.$route.params.type));
    },

    totalAnswered: function() {
      if(this.calculateProgress) {
        return this.calculateProgress.completedQuestions
      }
      return 0
    },
    questionCount: function() {
      if(this.calculateProgress) {
        return this.calculateProgress.totalQuestions
      }
      return 0
    },
    totalPercent: function() {
      return this.totalAnswered / this.questionCount * 100
    },
    progressClass: function() {
      return this.totalPercent === 100
          ? 'progress-bar bg-success'
          : 'progress-bar bg-info'
    },

    // An object of keys that describes the logic for hiding questions
    skipRules: function() {
      return this.skipTriggers.reduce((rules, value, index) => {
        const effectedQuestions = this.between(
            value.questionId,
            value.nextQuestionId
        )
        if (Array.isArray(rules[value.questionId])) {
          rules[value.questionId].push({
            ids: effectedQuestions,
            answer: value.triggerValue
          })
        } else {
          rules[value.questionId] =
              {
                ids: effectedQuestions,
                answer: value.triggerValue
              }
        }
        return rules
      }, {})
    },

    // An ojbect of keys that describs the logic for showing questions
    showRules: function() {
      return this.showTriggers.reduce((rules, value, index) => {
        if (Array.isArray(rules[value.questionId])) {
          rules[value.questionId].push({
            id: value.showQuestionId,
            answer: value.triggerValue
          })
        } else {
          rules[value.questionId] = [{
            id: value.showQuestionId,
            answer: value.triggerValue
          }]
        }
        return rules
      }, {})
    },

    skippedIds: function() {
      const hiddenIds = Object.keys(this.answers).reduce((result, key, index) => {
        const answer = this.answers[key]
        if (this.skipRules[answer.questionId]) {
          if ( this.skipRules[answer.questionId].answer == answer.answerString ) {
            result = result.concat(this.skipRules[answer.questionId].ids)
            return result
          }
        }
        return result
      }, [])
      // remove duplicates
      return hiddenIds.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    },

    // Name is a little deceptive. This is an array of objects that should be HIDDEN based on the SHOWN rules
    shownIds: function () {

      return Object.keys(this.answers).reduce((result, key, index) => {

        const answer = this.answers[key]

        if (this.showRules[answer.questionId.toString()]) {

          this.showRules[answer.questionId.toString()].forEach(rule => {
            if ( !answer.answers.includes(parseInt(rule.answer))) {

              result.push(rule.id)
            }

          })
        }

        return result
      }, [])
    }
  },

  methods: {

    parseQuestion(question){
      if (this.surveyType === 'medical-history') {
        question = question.toLowerCase();
        return question.charAt(0).toUpperCase() + question.slice(1)
      }
      return question
    },

    fakeSave: function () {
      this.fakeSuccess = false
      this.fakeSaving = true
      setTimeout(() => {
        this.fakeSaving = false
        this.fakeSuccess = true

        // Reset button
        setTimeout(() => {
          this.fakeSuccess = false
          this.nextSurvey()
        }, 1000)

      }, 1000)
    },



    nextSurvey(){

//      if(this.surveyType !== 'food') {
//        let kitId = this.$route.params.kitId
//        let nextSurvey = this.mapURLToNext(this.surveyType)
//        this.$router.push({path: '/surveys/' + nextSurvey + '/' + kitId})
//      }else {
        this.$router.push({ name: 'Surveys' })
//      }
    },

    mapURLToNext: function(key) {
      const questionTypes = {
        'day-of-sampling': 'medical-history',
        'medical-history': 'mental',
        'mental': 'exercise',
        'exercise': 'food',
      }
      return questionTypes[key] || null
    },

    mapURLToSurvey: function(key) {
      const questionTypes = {
        'food': 'FOOD',
        'medical-history': 'MEDICAL_HISTORY',
        'day-of-sampling': 'DAY_OF_SAMPLING',
        'exercise': 'EXERCISE',
        'mental': 'MENTAL'
      }
      return questionTypes[key] || key
    },

    // API returns UPPER_CASE keys for question with multiple names for same question type
    // So we map these keys to our 8 question types
    mapAnswerTypeToComponent: function(key) {
      const questionTypes = {
        DURATION_IN_DAYS: 'Number',
        DURATION_IN_MINUTES: 'Number',
        BOOLEAN: 'Boolean',
        NUMBER: 'Number',
        SINGLE_OPTION: 'SingleOption',
        DATE: 'Date',
        MULTI_OPTION: 'MultiOption',
        TEXT: 'TextQuestion'
      }

      return questionTypes[key] || key
    },
    isArrayAnswerQuestion: function(key) {
      return key === 'MULTI_OPTION' || key === 'SINGLE_OPTION'
    },
    isSingleAnswerQuestion: function(key) {
      return !this.isArrayAnswerQuestion(key)
    },
    // Return array of ints between 2 values
    between: function(min, max) {
      var list = []
      for (var i = min + 1; i < max; i++) {
        list.push(i)
      }
      return list
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    sectionTitle (index){
      if (this.surveyType === 'exercise') {
        if (index == 2) {
          return 'Part 1: Job-related physical activity'
        } else if(index == 8) {
          return 'Part 2: Transportation physical activity'
        } else if(index == 14) {
          return 'Part 3: House work, House maintenance and caring for family'
        } else if(index == 20) {
          return 'Part 4: Recreation, sport and leisure-time physical activity'
        } else if(index == 26) {
          return 'Part 5: Time spent sitting'
        }
      }

      if (this.surveyType === 'food') {
        if(index == 879) {
          return 'Dietary Restrictions'
        } else if(index == 885) {
          return 'Grains'
        } else if(index == 921) {
          return 'Fruit Consumption'
        } else if(index == 922) {
          return 'Types of Fruit Consumed'
        } else if(index == 958) {
          return 'Vegetable Consumption'
        } else if(index == 959) {
          return 'Types of Vegetables Consumed'
        }else if(index == 1020){
          return 'Nuts, Seeds, Pulses and Legumes'
        } else if(index == 1035) {
          return 'Meat, Fish and Eggs'
        } else if(index == 1059) {
          return 'Milk and Dairy Products'
        } else if(index == 1103) {
          return 'Snacks and Desserts'
        } else if(index == 1138) {
          return 'Additions'
        } else if(index == 1166) {
          return 'Drinks'
        }
      }

      if (this.surveyType === 'medical-history') {
        if (index == 49) {
          return 'Demographic Information'
        } else if (index == 83) {
          return 'Recent Medical History'
        } else if (index == 98) {
          return 'Vaccination History'
        } else if (index == 103) {
          return 'Detailed Medical History'
        } else if (index == 853) {
          return 'Supplements, Medications and Medical Treatments'
        }
      }

        return ''
    },
    sectionSubtitle (index){
      if (this.surveyType === 'food') {
        if(index == 923) {
          return 'This section asks you to provide an estimate of your overall fruit consumption. Please include fresh, frozen and tinned fruits. Do not include fruit juices in this section; we will ask about these in the drinks section.'
        } else if(index == 924) {
          return 'This section asks you to provide further information on the types of fruit you usually consume. Please include fresh, frozen and tinned fruits. Do not include fruit juices in this section; we will ask about these in the drinks section.'
        }  else if(index == 960) {
          return 'This section asks you to provide an estimate of your overall vegetable consumption. Please include fresh, frozen or tinned vegetables. Do not include vegetable juices in this section; we will ask about these in the drinks section.'
        } else if(index == 961) {
          return 'This section asks you to provide further information on the types of vegetables you usually consume. Please includes fresh, frozen and tinned vegetables. Do not include vegetable juices in this section; we will ask about these in the drinks section.'
        }
      }
      return ''
    },

    fetchSurvey(){
      this.isLoaded = false
      this.$store
      .dispatch('getSurveyQuestions', this.$route.params.type)
      .then(response => {
        const questions = response.data.questions
        const obj = questions.reduce((object, value) => {
          object[value.id] = value
          return object
        }, {})
        const defaultQuestions = questions.reduce((object, value) => {
          object[value.id] = {
            questionId: value.id,
            answers: [],
            answerString: ''
          }
          return object
        }, {})
        Vue.set(this, 'questions', obj)
        Vue.set(this, 'skipTriggers', response.data.skipTriggers)
        Vue.set(this, 'showTriggers', response.data.showTriggers)

        this.$store
        .dispatch('getSurveyAnswers', {
          type: this.$route.params.type,
          kitId: this.$route.params.kitId
        })
        .then(response => {
          const questions = {
            ...defaultQuestions,
            ...response.data.questionResultsMap
          }
          Vue.set(this, 'answers', questions)
          this.isLoaded = true
        })
        .catch(error => {
          console.log(error)
          this.isLoaded = true
        })
      })
    },

    goBack () {
      this.$router.go(-1)
    }
  },
 mounted: function() {

    window.addEventListener('scroll', this.updateScroll);

    this.fetchSurvey()
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  watch:{
    $route (to, from){
      this.fetchSurvey()
    }
  }
}
</script>

<style scoped lang="scss">
.app-body main {
  padding-top: 0 !important;

}
.question-list{
 padding-bottom: 3rem;
}

.plain{
  border: 1px solid red;
  padding: 5px;
  font-size: 10px;
  margin-bottom: 1rem;
  display: inline-block;
}
#debug {
  position: fixed;
  top: 50px;
  right: 50px;
  width: 500px;
  height: 500px;
  background: white;
  border: 1px solid red;
  padding: 10px;
  overflow: scroll;
  z-index: 100000000;
  opacity: 0.6;
}

.questionnaire-description {
  margin-bottom: 2rem;
  margin-top:-2rem;

  @media (min-width:768px) {
    margin-top:0;
  }

  .description {
    font-size:1rem;
    margin-top: 1rem;
  }
}

.header-primary-info {
  position:relative;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  justify-conetnt:center;
  width:100%;

  @media (min-width:768px) {
    justify-conetnt:flex-start;
  }

  a {
    margin-bottom:0;
  }
  h2 {
    margin-bottom:0;
    font-weight:500;
  }

  .survey-back-btn {
    height:25px;
    width:25px;
    position:absolute;
    left:0px;
    display:flex;
    justify-content:center;
    align-items:center;
    border-radius:2px;

    @media (min-width:768px) {
      height:20px;
      width:20px;
      position:relative;
      margin-right:1rem;
      margin-bottom:1rem;
    }
  }
}

.header-meta {
  flex-basis:0;
  display:flex;
  flex-wrap:nowrap;
  align-items:center;
  align-content:center;

  @media (min-width:768px) {
    flex-wrap:wrap;
    align-content:space-between;
  }

  p {
    margin-bottom:0;
    white-space: nowrap;
    color: #00193D;
  }

  .header-meta-kit-id {
    font-size: 0.875rem;
    font-weight: 500;
  }
}

.header-inner {
  transition: all 0.25s ease;
  margin-bottom:1rem;
  display:flex;
  justify-content:center;
  flex-wrap:wrap;

  @media (min-width:768px) {
    margin-bottom:1.5rem;
    justify-content:space-between;
    flex-wrap:nowrap;
  }
}

.main {
  padding-top:0px;
}

.header-primary-info h2 {
  padding-left: 10px;
}

.btn-q-back{
  width:160px;
}

header.skinny {
  @media (min-width:768px) {
    .header-inner {
      margin-bottom: 0.75rem;
    }

    .header-primary-info {
      flex-wrap:nowrap;
    }

    .header-meta {
      flex-wrap:nowrap;

      .header-meta-kit-id {
        margin-right:1rem;
      }
    }

    .survey-back-btn {
      margin-bottom:0;
      margin-right:1.5rem;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/application/customer/SurveysQuestions.vue